export const hiraganaRegExp = /^[ぁ-んー( |　)]+$/;
export const passwordRegExp = /^((?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d!-/:-@¥[-`{-~]{8,})*$/;
export const postCodeRegExp = /^(\d{7}|\d{3}-\d{4}|)$/;
export const numberExp = /^[0-9]+$|^$/;
